export interface WireSpec {
  id: string
  sourceClientId: string
  kind: 'rejoin' | 'end'
  targetClientId?: string
}
export interface RoutedWire extends WireSpec {
  laneIndex: number
}

/**
 * Assign gutter lanes so end-of-script wires nest INSIDE rejoin wires (never cross),
 * and sibling rejoins ride adjacent lanes. Overflow past maxLanes is dropped so the
 * overlay can thin/hide rather than draw spaghetti.
 */
export function assignWireLanes(
  wires: WireSpec[],
  opts?: { maxLanes?: number },
): { routed: RoutedWire[]; dropped: WireSpec[] } {
  const maxLanes = opts?.maxLanes ?? 6
  const ends = wires.filter((w) => w.kind === 'end')
  const rejoins = wires.filter((w) => w.kind === 'rejoin')

  const routed: RoutedWire[] = []
  const dropped: WireSpec[] = []
  let lane = 0

  // Inner lanes first: terminations.
  for (const e of ends) {
    if (lane >= maxLanes) {
      dropped.push(e)
      continue
    }
    routed.push({ ...e, laneIndex: lane++ })
  }
  // Outer lanes: rejoins.
  for (const r of rejoins) {
    if (lane >= maxLanes) {
      dropped.push(r)
      continue
    }
    routed.push({ ...r, laneIndex: lane++ })
  }
  return { routed, dropped }
}
